import type { Ssm5FreezeFrameValue } from '@packages/domain/ssm5';

/** Translated text for a value that was not captured or cannot be shown. */
export type Ssm5FreezeFrameValueTexts = {
    /** The text for a value that was not captured. */
    empty: string;
    /** The text for a value that cannot be shown. */
    invalid: string;
};

/**
 * Write a captured value or the translated text of its state.
 *
 * @param value - the captured value
 * @param texts - the translated state texts
 * @returns the cell text
 */
export function freezeFrameValueText(value: Ssm5FreezeFrameValue, texts: Ssm5FreezeFrameValueTexts): string {
    return value.state === 'valid' ? value.text : texts[value.state];
}
